export default [
  {
    path: '/transfers_erc721',
    name: 'ERC721TransferView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/ERC721TransferView.vue'
      ),
    meta: { title: 'ERC721 Transfers', group: 'erc721' },
  },
  {
    path: '/holders_erc721',
    name: 'ERC721HolderView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/ERC721HolderView.vue'
      ),
    meta: { title: 'ERC721 Holders', group: 'erc721' },
  },
  {
    path: '/inventory_erc721',
    name: 'ERC721InventoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/ERC721InventoryView.vue'
      ),
    meta: { title: 'ERC721 Inventory', group: 'erc721' },
  },
  {
    path: '/transaction_erc721',
    name: 'ERC721TransactionView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/ERC721TransactionView.vue'
      ),
    meta: { title: 'ERC721 Transaction', group: 'erc721' },
  },
  {
    path: '/minting_request_nft721',
    name: 'NFT721AddView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/NFT721AddView.vue'
      ),
    meta: { title: 'NFT721 Minting Request', group: 'erc721' },
  },
  {
    path: '/minting_process_nft721',
    name: 'NFT721MintView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/NFT721MintView.vue'
      ),
    meta: { title: 'NFT721 Minting Process', group: 'erc721' },
  },
  {
    path: '/minting_history_nft721',
    name: 'NFT721MintHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc721" */ '@/views/ERC721/NFT721MintHistoryView.vue'
      ),
    meta: { title: 'NFT721 Minting History', group: 'erc721' },
  },
]
